<template>
  <div class="main-wrapper" style="padding: 10px 30px 30px">
    <el-row v-if="themeName" :gutter="20">
      <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
        部署模板：
        <el-link type="primary" :underline="false" style="margin-top: -5px" :href="themePreviewUrl || 'javascript:;'" :target="themePreviewUrl ? '_blank' : ''">
          {{ themeName }}
        </el-link>
      </el-col>
    </el-row>

    <div style="height: 15px"></div>

    <el-steps :active="active">
      <el-step title="选择版本" description="请选择适合您的产品版本"></el-step>
      <el-step title="确认选项" description="请确认购买时间以及其他选项"></el-step>
      <el-step title="在线支付" description="支付宝/微信在线支付"></el-step>
    </el-steps>

    <div style="height: 15px"></div>

    <template v-if="active === 0">
      <el-table :data="hostFeatures" style="width: 100%; margin: 0 10px" stripe size="large">
        <el-table-column prop="functions" label="功能（模块）"></el-table-column>
        <el-table-column prop="starter" :label="'入门版（¥' + priceStarter + '/年）'" width="180">
          <template #default="scope">
            <el-link v-if="scope.row.functions && scope.row.starter === true" type="success" :underline="false" @click.prevent>
              支持
            </el-link>
            <el-link
              v-else-if="scope.row.functions && scope.row.starter === false"
              type="danger"
              :underline="false"
              @click.prevent
            >
              不支持
            </el-link>
            <el-link v-else-if="scope.row.functions && scope.row.starter" :underline="false" @click.prevent>
              {{ scope.row.starter }}
            </el-link>
            <el-button v-else type="success" @click.prevent="btnBuyClick('Starter')">购买入门版</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="standard" :label="'标准版（¥' + priceStandard + '/年）'" width="180">
          <template #default="scope">
            <el-link v-if="scope.row.functions && scope.row.standard === true" type="success" :underline="false" @click.prevent>
              支持
            </el-link>
            <el-link
              v-else-if="scope.row.functions && scope.row.standard === false"
              type="danger"
              :underline="false"
              @click.prevent
            >
              不支持
            </el-link>
            <el-link v-else-if="scope.row.functions && scope.row.standard" :underline="false" @click.prevent>
              {{ scope.row.standard }}
            </el-link>
            <el-button v-else type="success" @click.prevent="btnBuyClick('Standard')">购买标准版</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="professional" :label="'专业版（¥' + priceProfessional + '/年）'" width="180">
          <template #default="scope">
            <el-link
              v-if="scope.row.functions && scope.row.professional === true"
              type="success"
              :underline="false"
              @click.prevent
            >
              支持
            </el-link>
            <el-link
              v-else-if="scope.row.functions && scope.row.professional === false"
              type="danger"
              :underline="false"
              @click.prevent
            >
              不支持
            </el-link>
            <el-link v-else-if="scope.row.functions && scope.row.professional" :underline="false" @click.prevent>
              {{ scope.row.professional }}
            </el-link>
            <el-button v-else type="success" @click.prevent="btnBuyClick('Professional')">购买专业版</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-else-if="active === 1">
      <el-form style="margin: 0 30px" ref="buyForm" :model="buyForm" label-position="top">
        <el-form-item label="网站云版本" prop="hostType" :rules="{ required: true, message: '请选择网站云版本' }">
          <el-radio-group v-model="buyForm.hostType">
            <el-radio-button label="Starter">入门版（¥{{ priceStarter }}/年）</el-radio-button>
            <el-radio-button label="Standard">标准版（¥{{ priceStandard }}/年）</el-radio-button>
            <el-radio-button label="Professional">专业版（¥{{ priceProfessional }}/年）</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="购买时长" prop="year" :rules="{ required: true, message: '请选择购买时长' }">
          <el-radio-group v-model="buyForm.year">
            <el-radio-button :label="1">1年</el-radio-button>
            <el-radio-button :label="2">2年（8.5折）</el-radio-button>
            <el-radio-button :label="3">3年（8折）</el-radio-button>
            <el-radio-button :label="4">4年（7.5折）</el-radio-button>
            <el-radio-button :label="5">5年（7折）</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选项" prop="isHongKong">
          <el-switch v-model="buyForm.isHongKong" active-text="香港服务器"></el-switch>
          <div class="small tips">使用香港服务器后，网站服务器位于香港，<span style="color: red">免备案</span>，解析域名后可立即上线运行</div>
        </el-form-item>
        <el-form-item label="服务协议" prop="agreement">
          <el-checkbox v-model="buyForm.agreement">同意</el-checkbox>
          <el-link href="/home/cloud-agreement.html" target="_blank" style="margin-top: -3px">网站云服务协议</el-link>
        </el-form-item>
        <el-form-item v-if="themePrice" label="费用明细">
          <div style="margin-left: 30px">
            模板：
            <span style="font-size: 16px; color: #fa5300">￥{{ getPayAmount('theme').toFixed(2) }}</span>
            <span>{{ getThemeDiscount() }}</span>
            <br />
            网站云：
            <span style="font-size: 16px; color: #fa5300">￥{{ getPayAmount('host').toFixed(2) }}</span>
            <span v-if="buyForm.year == 2">（8.5折）</span>
            <span v-else-if="buyForm.year == 3">（8折）</span>
            <span v-else-if="buyForm.year == 4">（7.5折）</span>
            <span v-else-if="buyForm.year == 5">（7折）</span>
          </div>
        </el-form-item>
        <el-form-item label="费用合计">
          <span style="font-size: 18px; color: #fa5300">￥{{ getPayAmount('all').toFixed(2) }}</span>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer" style="text-align: center">
          <el-button type="default" @click.prevent="btnPreviousClick">上一步</el-button>
          <el-button type="primary" :disabled="!buyForm.agreement" @click.prevent="btnNextClick">下一步</el-button>
        </div>
      </el-form>
    </template>
    <template v-else-if="active === 2">
      <template v-if="payForm.isPurchased">
        <div style="text-align: center">
          <h3 style="text-align: center; color: #67c23a">{{ getPaySuccessMessage() }}</h3>
          <el-button type="primary" v-on:click="btnPayCloseClick">进入我的网站云</el-button>
        </div>
      </template>
      <template v-else-if="payForm.isQrCode">
        <div style="text-align: center">
          <h3>打开手机{{ getChannel() }}，扫一扫下面的二维码，即可完成支付</h3>
          <div style="margin: 10px auto">
            <img v-if="payForm.channel == 'AliPay'" src="/home/img/channel_alipay.gif" />
            <img v-else src="/home/img/channel_weixin.gif" />
          </div>
          <canvas id="qrcode" style="margin: 0px auto; width: 260px; height: 260px"></canvas>
        </div>
      </template>
      <template v-else>
        <div style="margin-bottom: 10px; border: 1px solid #ebebeb; border-radius: 3px">
          <div style="padding: 24px">
            <h3 style="text-align: center; margin-bottom: 40px" v-html="getPayDescription()"></h3>

            <el-divider></el-divider>

            <div style="text-align: center">
              <div
                style="
                  width: 49%;
                  text-align: center;
                  border-right: 1px solid #eff2f6;
                  display: inline-block;
                  width: 49%;
                  box-sizing: border-box;
                  vertical-align: top;
                "
              >
                <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                  <img src="/home/img/channel_alipay.gif" />
                </span>
                <div class="el-image">
                  <el-button type="primary" v-on:click="btnPayChannelClick('AliPay')">使用支付宝支付</el-button>
                </div>
              </div>
              <div
                style="
                  width: 49%;
                  text-align: center;
                  display: inline-block;
                  width: 49%;
                  box-sizing: border-box;
                  vertical-align: top;
                "
              >
                <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                  <img src="/home/img/channel_weixin.gif" />
                </span>
                <div class="el-image">
                  <el-button type="primary" v-on:click="btnPayChannelClick('WxPay')">使用微信支付</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <p style="height: 30px"></p>
    </template>
  </div>
</template>

<script lang="ts">
import api from '@/api/my/create';
import { HOST_FEATURES } from '@/const';
import { HostType } from '@/types/enums';
import utils from '@/utils';
import { defineComponent } from 'vue';
import QRCode from 'qrcode';

interface IHostFeature {
  functions: string;
  starter: boolean;
  standard: boolean;
  professional: boolean;
}

interface IBuyForm {
  hostType: string;
  year: number;
  isHongKong: boolean;
  agreement: boolean;
}

interface IPayForm {
  hostType: string;
  year: number;
  isHongKong: boolean;
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface IState {
  active: number;
  themeUserName: string;
  themeName: string;
  hostFeatures: IHostFeature[];
  themePreviewUrl: string;
  themePrice: number;
  themeDiscountStarter: number;
  themeDiscountStandard: number;
  themeDiscountProfessional: number;
  priceStarter: number;
  priceStandard: number;
  priceProfessional: number;
  discount1Year: number;
  discount2Year: number;
  discount3Year: number;
  discount4Year: number;
  discount5Year: number;
  buyForm: IBuyForm;
  payForm: IPayForm;
}

export default defineComponent({
  data() {
    return {
      active: 0,
      themeUserName: '',
      themeName: '',
      hostFeatures: HOST_FEATURES,
      themePreviewUrl: '',
      themePrice: 0,
      themeDiscountStarter: 0,
      themeDiscountStandard: 0,
      themeDiscountProfessional: 0,
      priceStarter: 0,
      priceStandard: 0,
      priceProfessional: 0,
      discount1Year: 0,
      discount2Year: 0,
      discount3Year: 0,
      discount4Year: 0,
      discount5Year: 0,
      buyForm: {} as IBuyForm,
      payForm: {} as IPayForm,
    } as IState;
  },
  methods: {
    apiGet() {
      this.active = 0;
      this.themeUserName = '';
      this.themeName = '';
      const resource = this.$route?.params?.resource as string;
      if (resource && resource.indexOf('-') !== -1) {
        [this.themeUserName, this.themeName] = resource.split('-');
      }

      api.get(
        {
          themeUserName: this.themeUserName,
          themeName: this.themeName,
        },
        (res) => {
          this.themePreviewUrl = res.themePreviewUrl;
          this.themePrice = res.themePrice;
          this.themeDiscountStarter = res.themeDiscountStarter;
          this.themeDiscountStandard = res.themeDiscountStandard;
          this.themeDiscountProfessional = res.themeDiscountProfessional;
          this.priceStarter = res.priceStarter;
          this.priceStandard = res.priceStandard;
          this.priceProfessional = res.priceProfessional;
          this.discount1Year = res.discount1Year;
          this.discount2Year = res.discount2Year;
          this.discount3Year = res.discount3Year;
          this.discount4Year = res.discount4Year;
          this.discount5Year = res.discount5Year;
        },
      );
    },

    btnBuyClick(type: string) {
      this.buyForm.hostType = type;
      this.buyForm.year = 1;
      this.buyForm.isHongKong = false;
      this.buyForm.agreement = false;
      this.active = 1;
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getPayDescription() {
      const hostType = utils.getHostType(this.buyForm.hostType);
      const amount = this.getPayAmount('all').toFixed(2);
      let themeDesc = '';
      if (this.themePrice > 0) {
        themeDesc = `
        模板名称:
        <span style="color: #fa5300; margin-right: 15px">${this.themeName}</span>`;
      }
      return `
        网站云版本:
        <span style="color: #fa5300; margin-right: 15px">${hostType}${this.payForm.isHongKong ? '(香港)' : ''}</span>
        购买时长:
        <span style="color: #fa5300; margin-right: 15px">${this.payForm.year}年</span>
        ${themeDesc}
        费用合计:
        <span style="color: #fa5300">￥${amount}</span>`;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
            }
          },
        );
      }, 3000);
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          hostType: this.payForm.hostType,
          year: this.payForm.year,
          isHongKong: this.payForm.isHongKong,
          themeUserName: this.themeUserName,
          themeName: this.themeName,
          channel: this.payForm.channel,
          amount: this.getPayAmount('all'),
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    getThemeDiscount(): string {
      let discount = 1;
      const { hostType } = this.buyForm;
      if (hostType === HostType.Starter) {
        discount = this.themeDiscountStarter;
      } else if (hostType === HostType.Standard) {
        discount = this.themeDiscountStandard;
      } else if (hostType === HostType.Professional) {
        discount = this.themeDiscountProfessional;
      }
      return discount < 1 ? `（${discount * 10}折）` : '';
    },

    getPayAmount(contains: 'all' | 'host' | 'theme'): number {
      const { hostType } = this.buyForm;
      const { year } = this.buyForm;

      let price = 0;
      let themeDiscount = 1;
      if (hostType === HostType.Starter) {
        price = this.priceStarter;
        themeDiscount = this.themeDiscountStarter;
      } else if (hostType === HostType.Standard) {
        price = this.priceStandard;
        themeDiscount = this.themeDiscountStandard;
      } else if (hostType === HostType.Professional) {
        price = this.priceProfessional;
        themeDiscount = this.themeDiscountProfessional;
      }
      let discount = 1;
      if (year === 1) {
        discount = this.discount1Year;
      } else if (year === 2) {
        discount = this.discount2Year;
      } else if (year === 3) {
        discount = this.discount3Year;
      } else if (year === 4) {
        discount = this.discount4Year;
      } else if (year === 5) {
        discount = this.discount5Year;
      }

      const hostAmount = price * year * discount;
      const themeAmount = this.themePrice * themeDiscount;
      if (contains === 'host') {
        return hostAmount;
      }
      if (contains === 'theme') {
        return themeAmount;
      }
      return hostAmount + themeAmount;
    },

    getPaySuccessMessage() {
      if (this.themePrice > 0) {
        return '网站云及模板购买成功，请进入我的网站云安装并使用！';
      }
      return '网站云购买成功，请进入我的网站云安装并使用！';
    },

    btnPayCloseClick() {
      utils.pageClose(this.$route.fullPath, () => {
        utils.pageRedirect('/my/hosts', { r: Math.random() });
      });
    },

    btnPreviousClick() {
      this.active -= 1;
      if (this.active < 0) this.active = 0;
    },

    btnNextClick() {
      this.active += 1;
      if (this.active === 2) {
        this.payForm.hostType = this.buyForm.hostType;
        this.payForm.year = this.buyForm.year;
        this.payForm.isHongKong = this.buyForm.isHongKong;
        this.payForm.failureCount = 0;
      }
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      () => {
        this.apiGet();
      },
      { immediate: true },
    );
  },
});
</script>
